import React, { useEffect, useState } from "react";
import { Form, Select, Button, Row, Col, Steps, Checkbox } from "antd";
import { useSocket } from "@components/SocketProvider";
import toast from "react-hot-toast";
import FileDownload from "js-file-download";
import planningService from "@services/planning.service";

const { Step } = Steps;

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
};
/* eslint-enable no-template-curly-in-string */

let interval = undefined;

const downloadFile = (url) => {
  const e = document.createElement("a");
  e.href = url;
  e.download = url.substr(url.lastIndexOf("/") + 1);
  document.body.appendChild(e);
  e.click();
  document.body.removeChild(e);
};

const CellRef = () => {
  // eslint-disable-next-line
  const socket = useSocket();

  const [submitted, setSubmitted] = useState(false);
  const [fileLink, setFileLink] = useState("");
  const [progress, setProgress] = useState(0);
  const [regions, setRegions] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [provinces, setProvinces] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [cities, setCities] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [sites, setSites] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [form] = Form.useForm();

  useEffect(() => {
    if (submitted) {
      interval = setInterval(() => {
        setProgress((prev) => prev + 1);
      }, 100);
    } else {
      clearInterval(interval);
    }
  }, [submitted]);

  useEffect(() => {
    if (progress === 100 && fileLink) {
      setSubmitted(false);
      clearInterval(interval);
      downloadFile(fileLink);
    }
    // eslint-disable-next-line
  }, [progress]);

  async function fetchRegions() {
    setRegions({ ...regions, loading: true });

    try {
      const res = await planningService.fetchRegions();

      setRegions({
        ...regions,
        loading: false,
        data: res.data.map((r) => ({ label: r, value: r })),
      });
    } catch (error) {
      console.log(error);
      setRegions({ ...regions, loading: false, error: error });
    }
  }

  async function fetchProvinces() {
    setProvinces({ ...provinces, loading: true });
    try {
      const res = await planningService.fetchProvinces();
      setProvinces({
        ...provinces,
        loading: false,
        data: res.data.map((p) => ({ label: p, value: p })),
      });
    } catch (error) {
      console.log(error);
      setProvinces({ ...provinces, loading: false, error: error });
    }
  }

  async function fetchCities() {
    setCities({ ...cities, loading: true });

    try {
      const res = await planningService.fetchCities();
      setCities({
        ...cities,
        loading: false,
        data: res.data.map((c) => ({ label: c, value: c })),
      });
    } catch (error) {
      console.log(error);
      setCities({ ...cities, loading: false, error: error });
    }
  }

  async function fetchSites() {
    setSites({ ...sites, loading: true });

    try {
      const res = await planningService.fetchSites();
      setSites({
        ...sites,
        loading: false,
        data: res.data.map((s) => ({ label: s, value: s })),
      });
    } catch (error) {
      console.log(error);
      setSites({ ...sites, loading: false, error: error });
    }
  }

  function fetchDatas() {
    fetchProvinces();
    fetchRegions();
    fetchCities();
    fetchSites();
  }

  useEffect(() => {
    socket.on("progress", function (data) {
      // console.log("progress", data);
      setProgress(data);
    });

    fetchDatas();

    socket.on("message", function (data) {
      // console.log("message", data);
      if (data.s === 0) {
        setSubmitted(false);
        toast.error(data.message);
      }
    });
    // eslint-disable-next-line
  }, []);

  const onFinish = async (values) => {
    setProgress(0);
    setSubmitted(true);
    setFileLink("");
    try {
      const res = await planningService.downloadCellRef({
        ...values,
        io_id: socket.id,
      });
      FileDownload(res.data, "cell-ref.zip");
      // setFileLink(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      setSubmitted(false);
    }
  };

  return (
    <div className="p-5 h-full img-bg img-bg-tems">
      <div className="bg-white border border-gray-200 rounded-md p-5 flex-grow">
        <Form
          form={form}
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          validateMessages={validateMessages}
          // onValuesChange={handleFormValuesChange}
          initialValues={{
            technology: ["2G", "3G", "4G_TDD", "4G_FDD", "5G"],
          }}
        >
          <Row gutter={[14, 0]}>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
              <Form.Item
                name="region"
                label="Region"
                rules={[
                  {
                    type: "array",
                    // required: true,
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  maxTagCount={5}
                  options={regions.data}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
              <Form.Item
                name="province"
                label="Province"
                rules={[
                  {
                    type: "array",
                    // required: true,
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  maxTagCount={5}
                  options={provinces.data}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
              <Form.Item
                name="city"
                label="City"
                rules={[
                  {
                    type: "array",
                    // required: true,
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  maxTagCount={5}
                  options={cities.data}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
              <Form.Item
                name="site"
                label="Site"
                rules={[
                  {
                    type: "array",
                    // required: true,
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  maxTagCount={5}
                  options={sites.data}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={9}>
              <Form.Item
                name="technology"
                label="Technology"
                rules={[
                  {
                    type: "array",
                    // required: true,
                  },
                ]}
              >
                <Checkbox.Group
                  style={{
                    width: "100%",
                  }}
                >
                  <Row>
                    <Col span={8}>
                      <Checkbox value="2G">2G</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="3G">3G</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="4G_TDD">4G TDD</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="4G_FDD">4G FDD</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="5G">5G</Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </Col>

            <Col flex="auto" className="flex justify-end items-end">
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={submitted}
                  className="mt-4"
                >
                  Download
                </Button>
                <Button
                  style={{ margin: "0 8px" }}
                  onClick={() => {
                    form.resetFields();
                  }}
                >
                  Clear
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {submitted && (
          <div className="mt-10">
            <Steps
              percent={progress}
              current={
                progress < 25 ? 0 : progress < 50 ? 1 : progress < 75 ? 2 : 3
              }
              direction="horizontal"
              className="mt-5"
            >
              <Step
                title={progress < 20 ? "In Progress" : "Finished"}
                description="Waiting for server response"
              />
              <Step
                title={
                  progress < 25
                    ? "Waiting"
                    : progress < 50
                    ? "In Progress"
                    : "Finished"
                }
                description="Read from Database"
              />
              <Step
                title={
                  progress < 50
                    ? "Waiting"
                    : progress < 75
                    ? "In Progress"
                    : "Finished"
                }
                description="Create Excel file"
              />
              <Step
                title={
                  progress < 75
                    ? "Waiting"
                    : progress < 100
                    ? "In Progress"
                    : "Finished"
                }
                description="Download"
              />
            </Steps>
          </div>
        )}
      </div>
    </div>
  );
};

export default CellRef;
